var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuLibraryOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24 5a3 3 0 00-2.685 1.664v.001l-3.44 6.87A.995.995 0 003 14v6a3 3 0 003 3h16a3 3 0 003-3v-6-.038a.996.996 0 00-.115-.428l-3.44-6.869v-.001A3 3 0 0018.76 5H9.239zm13.14 8l-2.724-5.442-.002-.003A1 1 0 0018.76 7H9.24a1 1 0 00-.894.555l-.002.003L5.62 13H10a1 1 0 01.832.445L12.535 16h2.93l1.703-2.555A1 1 0 0118 13h4.38zM5 15v5a1 1 0 001 1h16a1 1 0 001-1v-5h-4.465l-1.703 2.555A1 1 0 0116 18h-4a1 1 0 01-.832-.445L9.465 15H5z"
  })));
}
export default SvgMenuLibraryOutline;